export const PHONE_SCREEN_WIDTH = 320

export const IPAD_SCREEN_WIDTH = 768

export const LARGE_SCREEN_WIDTH = 1024
